import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MockInterviewStatisticsSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function MockInterviewStatisticsSubTab() {
  const [statistics, setStatistics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingStat, setEditingStat] = useState(null);
  const [formData, setFormData] = useState({ status: false });

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/completed-mock-interviews`);
      setStatistics(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке статистики: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (stat) => {
    setEditingStat(stat);
    setFormData({
      status: stat.status
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        status: formData.status
      };
      
      await axios.put(`${API_URL}/api/completed-mock-interviews/${editingStat.id}`, payload);
      setEditingStat(null);
      setFormData({ status: false });
      fetchStatistics();
    } catch (err) {
      setError('Ошибка при обновлении статистики: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleCancel = () => {
    setEditingStat(null);
    setFormData({ status: false });
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить эту запись?')) {
      try {
        await axios.delete(`${API_URL}/api/completed-mock-interviews/${id}`);
        fetchStatistics();
      } catch (err) {
        setError('Ошибка при удалении записи: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="mock-interview-statistics-sub-tab">
      <div className="tab-header">
        <h3>Статистика прохождений Mock-собеседований</h3>
      </div>

      {error && <div className="error-message">{error}</div>}

      {editingStat && (
        <div className="form-container">
          <h4>Редактировать статус прохождения</h4>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="status">
                <input
                  type="checkbox"
                  id="status"
                  checked={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.checked })}
                />
                {' '}Прошел собеседование
              </label>
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                Сохранить
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Название собеседования</th>
              <th>Telegram ID пользователя</th>
              <th>Статус прохождения</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {statistics.length === 0 ? (
              <tr>
                <td colSpan="5" className="empty-state">
                  Нет записей о прохождении mock-собеседований.
                </td>
              </tr>
            ) : (
              statistics.map((stat) => (
                <tr key={stat.id}>
                  <td>{stat.id}</td>
                  <td>{stat.mock_interview_title || 'N/A'}</td>
                  <td>{stat.user_telegram_id || 'N/A'}</td>
                  <td>
                    <span className={`status-badge ${stat.status ? 'status-completed' : 'status-not-completed'}`}>
                      {stat.status ? '✓ Прошел' : '✗ Не прошел'}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn-icon btn-edit"
                      onClick={() => handleEdit(stat)}
                      title="Редактировать"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(stat.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MockInterviewStatisticsSubTab;
